export class UnitOfMeasureConverter {
    public static convert(value: number, fromUm: string, toUm: string) {
        if (value) {
            if (fromUm === "celsius" && toUm === "fahrenheit") {
                return value * 1.8 + 32.0;
            }
            if (fromUm === "fahrenheit" && toUm === "celsius") {
                return (value - 32.0) / 1.8;
            }
        }
        return value;
    }

    public static convertTemperature(value: number, toUm: string, lang: any) {
        if (lang !== "en-US" && lang !== "en_US") {
            return value;
        }
        return UnitOfMeasureConverter.convert(value, "fahrenheit", "celsius");
    }

    public static getTemperatureUnitOfMeasure(currentLang: any) {
        if (currentLang === "en-US" || currentLang === "en_US") {
            return "°F";
        }
        return "°C";
    }
}
